import "./Footer.css";

const Footer = () => {
  const contactInfo = {
    office: {
      title: "Bangalore Office Location",
      address: "K-607 SY No. 1018156/2",
      details: "D Thogur, Niladri",
      area: "Electronic City Phase 1",
      city: "Bangalore",
      state: "Karnataka, India - 560100",
    },
    // branchOffice: {
    //   title: "Bangalore Office Location",
    //   address: "K-607 SY No. 1018156/2",
    //   details: "D Thogur, Niladri",
    //   area: "Electronic City Phase 1",
    //   city: "Bangalore",
    //   state: "Karnataka, India - 560100",
    // },
    email: {
      title: "Email",
      emails: ["connect@babitapack.com"],
    },
    phone: {
      title: "Phone",
      numbers: ["+91 8217782548"],
    },
  };

  const socialLinks = [
    { name: "Facebook", icon: "facebook", url: "https://facebook.com" },
    { name: "Instagram", icon: "instagram", url: "https://instagram.com" },
    { name: "WhatsApp", icon: "whatsapp", url: "https://wa.me/918217782548" },
    { name: "LinkedIn", icon: "linkedin", url: "https://www.linkedin.com/in/babita-25075a326/" },
  ];

  const handleSubscribe = (e) => {
    e.preventDefault();
    const emailInput = e.target.elements.email.value;
    if (emailInput) {
      alert(`Subscribed with: ${emailInput}`);
      e.target.reset();
    }
  };

  const renderIcon = (iconName) => {
    return (
      <img
        src={`/images/${iconName}.svg`}
        alt={iconName}
        width="32"
        height="32"
      />
    );
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left Section - Contact Info */}
        <div className="footer-left">
          <h2>We are happy to connect with you :</h2>

          <div className="contact-grid">
            {/* Corporate Office */}
            <div className="office-location">
              <h3>{contactInfo.office.title}</h3>
              <p>
                {contactInfo.office.address}, {contactInfo.office.details}
              </p>
              <p>{contactInfo.office.area}</p>
              <p>{contactInfo.office.city}</p>
              <p>{contactInfo.office.state}</p>
            </div>

            {/* Contact Details */}
            <div className="contact-details">
              <div className="email-section">
                <h3>{contactInfo.email.title}</h3>
                {contactInfo.email.emails.map((email, index) => (
                  <p key={index}>
                    <a href={`mailto:${email}`} style={{ color: "white" }}>
                      {email}
                    </a>
                  </p>
                ))}
              </div>

              <div className="phone-section">
                <h3>{contactInfo.phone.title}</h3>
                <p>
                  {contactInfo.phone.numbers.map((num, index) => (
                    <a key={index} href={`tel:${num}`} style={{ color: "white" }}>
                      {num}
                    </a>
                  ))}
                </p>
              </div>
            </div>

            {/* Branch Office */}
            {/* <div className="branch-office-location">
              <h3>{contactInfo.branchOffice.title}</h3>
              <p>
                {contactInfo.branchOffice.address}, {contactInfo.branchOffice.details}
              </p>
              <p>{contactInfo.branchOffice.area}</p>
              <p>{contactInfo.branchOffice.city}</p>
              <p>{contactInfo.branchOffice.state}</p>
            </div> */}
          </div>
        </div>

        {/* Right Section - Social & Subscription */}
        <div className="footer-right">
          <h2>Follow Us on :</h2>
          <div className="social-icons">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                className="social-icon"
                aria-label={social.name}
                target="_blank"
                rel="noopener noreferrer"
              >
                {renderIcon(social.icon)}
              </a>
            ))}
          </div>

          {/* Newsletter Subscription */}
          <div className="newsletter">
            <h3>Subscribe for Newsletters</h3>
            <form onSubmit={handleSubscribe}>
              <div className="input-group">
                <input type="email" name="email" placeholder="Your Email ID" required />
                <button type="submit" aria-label="Subscribe">▶</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>Copyright © babitapack.com</p>
        <p>Design & Development by Elaratech Labs</p>
      </div>
    </footer>
  );
};

export default Footer;
